import { Component, OnInit, Input } from '@angular/core';
import { GatesService } from '../_services/gates.service';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { Subject, takeUntil } from 'rxjs';
@AutoUnsubscribe
@Component({
  selector: 'app-gate-card',
  templateUrl: './gate-card.component.html',
  styleUrls: ['./gate-card.component.scss']
})
export class GateCardComponent implements OnInit {
  @Input() gate;
  mapControls;
  infoClass = false;
  currLang;
  destroy$ = new Subject<void>(); 
  constructor(
    private controlDeletion: ControlDeletionService,
    private globalService: GlobalService,
    private translate: TranslateService, 
    private gatesService: GatesService) { 
      this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
        //console.log('(c)gate-card_(f)getLang_(L)27' , lng);
        this.currLang = lng;
        this.translate.use(this.currLang);
      });
    }

  ngOnInit(): void {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
      //console.log('(c)gate-card_(f)getLang_(L)35' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    
    this.setMapData();
  }

  toggleInfo() {
    this.infoClass = !this.infoClass;
  }

  setMapData() {
    this.mapControls = {
      mapPoint: {
        lat: this.gate.lat,
        long: this.gate.long,
      },
      mapaddress: [{
        lat: this.gate.lat,
        long: this.gate.long,
      }],
      mapRoutes: [],
      circles: [
        {
          lat: this.gate.lat,
          long: this.gate.long,
          color: 'green',
          radius: this.gate.area,
        }
      ]
    }
  }

  mapEventHandle(event) {
    switch (event.type) {
      case "mapClicked":
        break;
    }
  }

  editGate() {
    this.gatesService.getGate(this.gate.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)gate-card_(f)editGate_(L)78' , res);
      this.gatesService.setGateData(res);
      $("#addGateModal").modal("show");
      $(`#addGateModal .modal-body`)[0].scrollTop = 0;
    })
  }

  deleteGate() {
    let body = { 'type': 'gates', 'gate': this.gate }
    this.controlDeletion.setDeletedRows(body)
    $("#deleteModal").modal("show");
  }

  ngOnDestroy(): void {
  }
}
